module.exports = __webpack_public_path__ + "static/RegisterLanguage-ca5d661a50f25b1e9f5f93e08fd24636.png";